export const linksts = [
    {
        "nombre" : "Tramites y Servicios",
        "link" : "https://ruts.hidalgo.gob.mx/?undefined&entidad=Secretar%C3%ADa%20de%20Trabajo%20y%20Previsi%C3%B3n%20Social",
        "submenu" : [
            {
                "subMenuNombre" : "Tramites y Servicios",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/?undefined&entidad=Secretar%C3%ADa%20de%20Trabajo%20y%20Previsi%C3%B3n%20Social"
            },
            {
                "subMenuNombre" : "Portal del Empleo",
                "subMenuUrl" : "https://www.empleo.gob.mx/vacantes/hidalgo"
            },
            {
                "subMenuNombre" : "Denuncias laborales",
                "subMenuUrl" : "http://justicialaboral.hidalgo.gob.mx/st/dgtyps/denuncias/"
            },
            {
                "subMenuNombre" : "Encuestas",
                "subMenuUrl" : "http://justicialaboral.hidalgo.gob.mx/st/encuestas/"
            },
            {
                "subMenuNombre" : "Citas",
                "subMenuUrl" : "https://s-trabajo.hidalgo.gob.mx/citas/"
            }
        ]
    }
]